import { supabase } from "@/integrations/supabase/client";

/**
 * Annule un brouillon Juliette resté en statut 'pending' parce que l'agent a
 * fermé la fenêtre sans décider (croix, Échap, clic dehors, changement de page).
 *
 * Sans ce nettoyage, ces brouillons "fantômes" restent en base pour toujours et
 * consomment le quota anti-spam (cap journalier de generate-relance-email /
 * generate-relance-whatsapp), bloquant l'agent alors qu'il n'a rien envoyé.
 *
 * Le garde `.eq("status", "pending")` rend l'opération idempotente et sûre :
 * c'est un no-op si le brouillon a déjà été envoyé ('sent'), annulé ('rejected')
 * ou édité ('approved'/'modified'). On se fie donc à l'état DB comme source de
 * vérité, sans avoir à propager l'action de l'utilisateur à travers l'UI.
 */
export async function rejectAbandonedDraft(
  table: "pending_emails" | "pending_whatsapp",
  id: string,
): Promise<void> {
  await supabase
    .from(table)
    .update({ status: "rejected", reviewed_at: new Date().toISOString() } as never)
    .eq("id", id)
    .eq("status", "pending");
}
